module.exports = __webpack_public_path__ + "static/media/flag-gn.f2eca5d0.webp";